import React, { Component } from "react";

import {
  AppBar,
  Button,
  Grid,
  IconButton,
  Paper,
  Toolbar,
  Typography
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { Form, Field } from "react-final-form";
import { TextField } from "final-form-material-ui";
import { styled, withStyles } from "@material-ui/core/styles";
import MySnackbar from "./MySnackbar";

import { Link } from "react-router-dom";
import { initChangePasswordRequest } from "../actions";
import { connect } from "react-redux";
import { history } from "../helpers/history";
import { addUrlProps } from "react-url-query";

const styles = theme => ({
  root: {
    flexGrow: 1,
    maxWidth: 600,
    margin: "0 auto"
  },
  link: {
    textDecoration: "none",
    color: "white"
  },
  title: {
    flexGrow: 1
  }
});

function mapUrlToProps(url, props) {
  return {
    username: url.username,
    resetCode: url.resetCode
  };
}

const MyGridItem = styled(Grid)({
  minHeight: 84
});

const validate = values => {
  const errors = {};
  if (!values.email) {
    errors.email = "Required";
  }
  if (!values.password) {
    errors.password = "Required";
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = "Required";
  }
  if (values.password !== values.confirmPassword) {
    errors.confirmPassword = "Passwords don't match";
  }
  return errors;
};

class ChangePasswordForm extends Component {
  constructor(props) {
    super(props);
    this.openDialog = false;
  }

  handleSubmit = values => {
    const request = { ...values, resetCode: this.props.resetCode };
    this.props.initChangePasswordRequest(request);
  };

  handleCloseDialog = () => {
    this.inError = false;
    this.setState({ inError: false });
    if (this.state.changed) {
      history.push("/");
    }
  };

  render() {
    const classes = this.props.classes;
    console.log(JSON.stringify(this.props));
    const initialValues = { email: this.props.username };
    if (this.props.message) {
      this.openDialog = true;
    } else {
      this.openDialog = false;
    }
    return (
      <div className={classes.root}>
        <AppBar title="Home" position="static">
          <Toolbar>
            <IconButton
              aria-controls="simple-menu"
              aria-haspopup="true"
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="Menu"
            >
              <a href="https://www.openempi.org" className={classes.link}>
                <MenuIcon />
              </a>
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              OpenEMPI Downloads
            </Typography>
          </Toolbar>
        </AppBar>
        <Form
          onSubmit={this.handleSubmit}
          initialValues={initialValues}
          validate={validate}
          render={({ handleSubmit, form, submitting, pristine }) => (
            <div>
              <form onSubmit={handleSubmit} noValidate>
                <Paper style={{ padding: 16 }}>
                  <Grid
                    container
                    alignItems="center"
                    justify="center"
                    direction="row"
                    spacing={2}
                  >
                    <MyGridItem item xs={10}>
                      <Field
                        fullWidth
                        required
                        name="email"
                        component={TextField}
                        type="email"
                        label="Email"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={5}>
                      <Field
                        fullWidth
                        required
                        name="password"
                        component={TextField}
                        type="password"
                        label="Password"
                      />
                    </MyGridItem>
                    <MyGridItem item xs={5}>
                      <Field
                        fullWidth
                        name="confirmPassword"
                        component={TextField}
                        type="password"
                        label="Confirm Password"
                      />
                    </MyGridItem>
                    <Grid item xs={12}>
                      <Grid container justify="center" spacing={3}>
                        <Grid item>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={submitting}
                          >
                            Submit
                          </Button>
                        </Grid>
                        <Grid item>
                          <Link to="/login">
                            <Button
                              type="submit"
                              variant="contained"
                              color="primary"
                              disabled={submitting}
                            >
                              Cancel
                            </Button>
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </form>
            </div>
          )}
        />
        <MySnackbar message={this.props.message} open={this.openDialog} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { changed, error } = state.changePassword;
  console.log("In mapStateToProps" + error);
  if (error) {
    return { changed, message: error };
  } else {
    return { changed };
  }
}

export default addUrlProps({ mapUrlToProps })(
  connect(
    mapStateToProps,
    { initChangePasswordRequest }
  )(withStyles(styles)(ChangePasswordForm))
);
